import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f1368d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expanded-profile-section-back-background" }
const _hoisted_2 = { class: "profile-section-back-header" }
const _hoisted_3 = { class: "profile-wrapper" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "sliced-address"
}
const _hoisted_6 = {
  key: 0,
  class: "tags-wrapper mt-2"
}
const _hoisted_7 = {
  key: 2,
  class: "mt-4",
  "data-testid": "app-balance"
}
const _hoisted_8 = { class: "profile-balance" }
const _hoisted_9 = {
  class: "amount is-flex is-align-items-center",
  "data-testid": "amount"
}
const _hoisted_10 = { class: "icon-button" }
const _hoisted_11 = { class: "symbol ml-2" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "link-list social"
}
const _hoisted_15 = {
  key: 1,
  class: "link-list"
}

import { useRouter } from 'vue-router'
import { computed, onMounted, ref, watch, watchEffect } from 'vue'
import browser from 'webextension-polyfill'

import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import ClipboardCopy from '@/popup/components/shared/ClipboardCopy/ClipboardCopy.vue'
import ProfileBackground from '@/popup/components/shared/ProfileBackground/ProfileBackground.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import UPWebsiteLink from '@/popup/components/shared/Miscellaneous/UPWebsiteLink.vue'
import { useAppStore } from '@/popup/store/AppStore'
import Tooltip from '@/popup/components/shared/Tooltip/Tooltip.vue'
import { truncateMiddle } from '@/shared/utils'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import { useUIStore } from '@/popup/store/UIStore'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import FormattedTokenAmount from '@/popup/components/shared/FormattedTokenAmount.vue'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import { useProfileStore } from '@/popup/store/ProfileStore'
import Skeleton from '@/popup/components/shared/Skeleton.vue'
import ProfileLinks from '@/popup/components/shared/ProfileLinks.vue'
import LinkButton from '@/popup/components/shared/LinkButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandedProfile',
  setup(__props) {

const appStore = useAppStore()
const uiStore = useUIStore()
const router = useRouter()
const preferencesStore = usePreferencesStore()
const profileStore = useProfileStore()
const { getWeb3Eth } = useWeb3Eth()
const { getBalance } = getWeb3Eth()

const balance = ref('')
const currentProfile = computed(() => appStore.currentProfile)
const toast = computed(() => uiStore.toast)

const readOnlyMode = ref(false)
const isTokenBalanceLoading = ref<boolean>(true)
watch(
  () => profileStore.deviceController,
  async newDeviceController => {
    if (!newDeviceController) {
      readOnlyMode.value = true
      return
    }
    readOnlyMode.value = newDeviceController.permissions.controlLevel === 'None'
  },
  { immediate: true }
)

onMounted(async () => {
  if (currentProfile.value) {
    balance.value = currentProfile.value.address
      ? await getBalance(currentProfile.value.address)
      : ''
    isTokenBalanceLoading.value = false
  }
})

watchEffect(async () => {
  if (currentProfile.value) {
    balance.value = currentProfile.value.address
      ? await getBalance(currentProfile.value.address)
      : ''
  }
})

const onLinkClick = (url?: string) => {
  url && browser.tabs.create({ url })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["expanded-profile-section", currentProfile.value.coverPicture ? '' : 'no-cover-picture'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ProfileBackground, {
          "profile-background": currentProfile.value.coverPicture,
          height: 224,
          width: 360
        }, null, 8 /* PROPS */, ["profile-background"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["profile-section-back-foreground", (currentProfile.value?.tags?.length || 0) > 0 ? 'no-tags' : ''])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Tooltip, {
            value: _ctx.$t('full_screen.reduce.tooltip'),
            "offset-distance": "0"
          }, {
            default: _withCtx(() => [
              _createVNode(SvgIcon, {
                height: "24",
                width: "24",
                name: "minimize",
                color: "var(--neutral-100)",
                "data-testid": "minimized",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'home' })))
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value"]),
          _createVNode(UPWebsiteLink, {
            class: _normalizeClass({
              hide: _unref(appStore).network?.id === 'testnet',
            })
          }, null, 8 /* PROPS */, ["class"]),
          (!readOnlyMode.value)
            ? (_openBlock(), _createBlock(Tooltip, {
                key: 0,
                value: _ctx.$t('profile.tooltip.edit'),
                "offset-distance": "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(SvgIcon, {
                    height: "24",
                    width: "24",
                    name: "edit",
                    color: "var(--neutral-100)",
                    "data-testid": "edit-profile",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                toast.value?.icon !== 'loading' &&
                  _unref(router).push({ name: 'edit-profile' })
              ))
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["value"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ProfilePicture, {
            "frontend-profile": currentProfile.value,
            size: "big",
            "with-identicon": false
          }, null, 8 /* PROPS */, ["frontend-profile"]),
          _createElementVNode("div", _hoisted_4, [
            (!currentProfile.value.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(truncateMiddle)(currentProfile.value.address)), 1 /* TEXT */))
              : (_openBlock(), _createBlock(UserName, {
                  key: 1,
                  profile: {
                name: currentProfile.value.name,
                address: currentProfile.value.address,
              },
                  "data-testid": "address",
                  "max-width": 210,
                  "has-at-sign": true,
                  "has-slice-address": true,
                  "name-class": "home-profile",
                  "address-class": "home-profile",
                  class: "is-justify-content-center"
                }, null, 8 /* PROPS */, ["profile"]))
          ]),
          (currentProfile.value.tags?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentProfile.value.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("lukso-tag", {
                    key: tag,
                    size: "small",
                    "is-rounded": true,
                    class: "tag-pill mx-2",
                    "background-color": "transparent",
                    "text-color": "neutral-100",
                    "data-testid": "tag",
                    name: "tag"
                  }, _toDisplayString(tag), 1 /* TEXT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (isTokenBalanceLoading.value)
            ? (_openBlock(), _createBlock(Skeleton, {
                key: 1,
                name: "loading-balance",
                width: "81",
                height: "28",
                class: "mt-4"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(FormattedTokenAmount, {
                    class: "icon-button",
                    decimals: 18,
                    amount: balance.value,
                    symbol: _unref(preferencesStore).token.symbol,
                    offset: "12"
                  }, {
                    default: _withCtx(({ amount, symbol }) => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(amount), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(symbol), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["amount", "symbol"])
                ])
              ]))
        ])
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createVNode(Scroll, {
      class: "profile-details",
      "hidden-tracks": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(`profile-details-inner ${toast.value ? 'custom-height' : ''}`)
        }, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('profile.info')), 1 /* TEXT */),
          _createVNode(ClipboardCopy, {
            value: currentProfile.value?.address,
            "has-hover-text": false,
            placement: "top",
            locked: "",
            "offset-distance": "5"
          }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                ref: "profilePictureRef",
                type: "text",
                readonly: "",
                value: currentProfile.value?.address,
                class: "form-control input-outline is-align-items-center address-input mt-1"
              }, null, 8 /* PROPS */, _hoisted_13)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value"]),
          _withDirectives(_createElementVNode("div", { class: "bio-details mt-4" }, _toDisplayString(currentProfile.value.description), 513 /* TEXT, NEED_PATCH */), [
            [_vShow, currentProfile.value.description]
          ]),
          _createVNode(ProfileLinks, {
            links: currentProfile.value.links
          }, {
            default: _withCtx(({ socialMediaLinks, otherLinks }) => [
              (socialMediaLinks.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialMediaLinks, (link, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createVNode(LinkButton, {
                          link: link,
                          size: "small",
                          onClick: ($event: any) => (onLinkClick(encodeURI(link?.url)))
                        }, null, 8 /* PROPS */, ["link", "onClick"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              (otherLinks.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherLinks, (link, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createVNode(LinkButton, {
                          link: link,
                          size: "small",
                          onClick: ($event: any) => (onLinkClick(encodeURI(link?.url)))
                        }, null, 8 /* PROPS */, ["link", "onClick"])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["links"])
        ], 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})